export const globalModals = {
    topUp: () => import("./top-up/payment/top-up"),
    confirm: () => import('./confirm'),
    mobileDetailedMenu: () => import('./mobile-detailed-menu'),
    attach2Fa: () => import('./2fa/attach'),
    confirm2Fa: () => import('./2fa/confirm'),
    confirmEmail: () => import('./email/confirm'),
    changeEmail: () => import('./email/change'),
};
